import ShareInviteCompact from "@/components/ShareInviteCompact";
import type { InviteKind } from "@/lib/inviteHelpers";

interface ShareInviteProps {
  invite_token: string;
  expiresAt?: string;
  inviterRole?: "parent" | "student";
  /** Which route the share URL points at. Defaults to the parent-student
   *  invite route; pass "gift" for the anonymous gift-claim flow. */
  kind?: InviteKind;
}

/**
 * Wrapper around ShareInviteCompact for backward compatibility.
 * Maps the old prop names to the new component.
 */
export default function ShareInvite({
  invite_token,
  expiresAt,
  inviterRole,
  kind
}: ShareInviteProps) {
  // Map inviterRole to context
  const context =
    inviterRole === "parent" ? "parent-to-student" : "student-to-parent";

  return (
    <ShareInviteCompact
      inviteToken={invite_token}
      context={context}
      expiresAt={expiresAt}
      kind={kind}
    />
  );
}
